var _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25833_193990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20062 0.599609H17.7524L27.4008 10.248V28.7998C27.4008 30.2357 26.2362 31.4004 24.8002 31.4004H7.20062C5.76468 31.4004 4.60004 30.2357 4.60004 28.7998V3.2002C4.60004 1.76426 5.76468 0.599609 7.20062 0.599609Z",
    fill: "white",
    stroke: "#C8D2E1",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6004 0.799805V7.9998C17.6004 9.32529 18.6749 10.3998 20.0004 10.3998H27.2004",
    stroke: "#C8D2E1",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000427246,
    y: 14.2002,
    width: 22,
    height: 14.2,
    rx: 1.6,
    fill: "#D92D20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9295 24.7998V18.2543H5.51188C6.00833 18.2543 6.43127 18.3492 6.7807 18.5388C7.13013 18.7263 7.39647 18.9873 7.57971 19.3218C7.76508 19.6542 7.85776 20.0377 7.85776 20.4724C7.85776 20.907 7.76401 21.2906 7.57651 21.623C7.38901 21.9553 7.11735 22.2142 6.76153 22.3996C6.40783 22.585 5.97957 22.6776 5.47673 22.6776H3.83077V21.5686H5.253C5.51934 21.5686 5.7388 21.5228 5.91138 21.4312C6.0861 21.3374 6.21607 21.2085 6.3013 21.0445C6.38866 20.8783 6.43234 20.6876 6.43234 20.4724C6.43234 20.2551 6.38866 20.0654 6.3013 19.9035C6.21607 19.7394 6.0861 19.6127 5.91138 19.5232C5.73667 19.4316 5.51508 19.3857 5.24661 19.3857H4.31337V24.7998H2.9295ZM10.897 24.7998H8.57664V18.2543H10.9161C11.5745 18.2543 12.1413 18.3854 12.6164 18.6475C13.0916 18.9074 13.457 19.2813 13.7127 19.7693C13.9705 20.2572 14.0994 20.841 14.0994 21.5207C14.0994 22.2025 13.9705 22.7884 13.7127 23.2785C13.457 23.7686 13.0894 24.1446 12.61 24.4067C12.1328 24.6688 11.5617 24.7998 10.897 24.7998ZM9.96052 23.6141H10.8394C11.2485 23.6141 11.5926 23.5416 11.8717 23.3968C12.153 23.2497 12.3639 23.0228 12.5046 22.716C12.6473 22.407 12.7187 22.0086 12.7187 21.5207C12.7187 21.037 12.6473 20.6418 12.5046 20.335C12.3639 20.0281 12.1541 19.8023 11.8749 19.6574C11.5958 19.5125 11.2517 19.4401 10.8426 19.4401H9.96052V23.6141ZM14.9445 24.7998V18.2543H19.2783V19.3953H16.3284V20.955H18.9907V22.096H16.3284V24.7998H14.9445Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25833_193990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white",
    transform: "translate(4.00043)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b7ef9f5c03c019809d2ea66aca5ef5c0.svg";
export { ForwardRef as ReactComponent };